import { Dimensions } from 'react-native';
const { width } = Dimensions.get('window');
// 是否是小屏幕
export const isMiniScreen = width <= 330;
export const SCREEN_WIDTH = width;
// 点击日期按钮的透明度
export const DAY_TOUCHABLE_OPACITY = 0.8;
// 选中后渐变颜色
export const DAY_SELECTED_COLORS = ['#00DDED', '#00CAD8'];
// 日历选择类型对应选中日期参数
export const SELECTED_DATE_NUM = {
    single: 1,
    range: 2,
    multi: 3
};
// 底部未选中默认文案
export const BOTTOM_OTHER_INFO_TEXT = '未选择';
// 日历类型
export const CALENDAR_TYPE = {
    SINGLE: 'single',
    RANGE: 'range',
    MULTI: 'multi'
};
